import { render, staticRenderFns } from "./physicianInfo.vue?vue&type=template&id=4d80a559&scoped=true&"
import script from "./physicianInfo.vue?vue&type=script&lang=js&"
export * from "./physicianInfo.vue?vue&type=script&lang=js&"
import style0 from "./physicianInfo.vue?vue&type=style&index=0&id=4d80a559&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80a559",
  null
  
)

export default component.exports